import styled, { css } from 'styled-components'
import media from 'css-in-js-media'

export const FullAbsolute = css`
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
`

export const DesktopView = styled.div`
    ${media('<desktop')} {
        display: none;
    }
`

export const MobileView = styled.div`
    ${media('>=desktop')} {
        display: none;
    }
`
